(() => {
  const COMPATIBILITY_SELECTOR = '[data-compatibility-help]';

  function parseSelectedVariant(sectionId) {
    const productInfo =
      document.querySelector(`#MainProduct-${sectionId}`) || document.querySelector(`#ProductInfo-${sectionId}`)?.closest('product-info');
    const selectedVariantNode = productInfo?.querySelector('variant-selects [data-selected-variant], variant-radios [data-selected-variant]');

    if (!selectedVariantNode?.textContent) return null;

    try {
      return JSON.parse(selectedVariantNode.textContent);
    } catch (error) {
      return null;
    }
  }

  function updateSku(sectionId, variant) {
    const root = document.getElementById(`Sku-${sectionId}`);
    if (!root) return;

    const value = `${variant?.sku || ''}`.trim();
    const valueNode = root.querySelector('[data-sku-value]');
    if (valueNode) valueNode.textContent = value;
    root.classList.toggle('visibility-hidden', !value);
  }

  function updateBarcode(sectionId, variant) {
    const root = document.getElementById(`ProductBarcode-${sectionId}`);
    if (!root) return;

    const valueNode = root.querySelector('[data-barcode-value]');
    const barcode = `${variant?.barcode || ''}`.trim();
    const fallback = `${root.dataset.fallback || ''}`.trim();
    const hideWhenEmpty = root.dataset.hideWhenEmpty === 'true';

    if (valueNode) {
      valueNode.textContent = barcode || fallback;
    }

    root.classList.toggle('hidden', hideWhenEmpty && !barcode);
  }

  function getCurrentItemLabel(root, sectionId, variant) {
    const skuFromVariant = `${variant?.sku || ''}`.trim();
    if (skuFromVariant) return skuFromVariant;

    const skuFromDom = document.querySelector(`#Sku-${sectionId} [data-sku-value]`)?.textContent?.trim();
    if (skuFromDom) return skuFromDom;

    return root.dataset.productTitle || document.title;
  }

  function updateWhatsAppLink(root, variant = null) {
    if (!root) return;

    const anchors = root.querySelectorAll('[data-compatibility-whatsapp]');
    if (!anchors.length) return;

    const sectionId = root.dataset.sectionId;
    const activeVariant = variant || parseSelectedVariant(sectionId);
    const template =
      root.dataset.whatsappTemplate ||
      'Hello, I am interested in this item: [item] + [url]. I need more information.';
    const item = getCurrentItemLabel(root, sectionId, activeVariant);
    const message = template.replace('[item]', item).replace('[url]', window.location.href);
    const phone = `${root.dataset.whatsappPhone || '393514773077'}`.replace(/[^\d]/g, '');

    anchors.forEach((anchor) => {
      anchor.href = `https://wa.me/${phone}?text=${encodeURIComponent(message)}`;
    });
  }

  function initializeCompatibility(scope = document) {
    scope.querySelectorAll(COMPATIBILITY_SELECTOR).forEach((root) => {
      updateWhatsAppLink(root);
    });
  }

  function handleVariantChange(payload) {
    const data = payload?.data;
    const sectionId = `${data?.sectionId || ''}`.trim();
    const variant = data?.variant;

    if (!sectionId || !variant) return;

    updateSku(sectionId, variant);
    updateBarcode(sectionId, variant);

    document
      .querySelectorAll(`${COMPATIBILITY_SELECTOR}[data-section-id="${sectionId}"]`)
      .forEach((root) => updateWhatsAppLink(root, variant));
  }

  document.addEventListener('click', (event) => {
    const whatsappTrigger = event.target.closest('[data-compatibility-whatsapp]');
    if (whatsappTrigger) {
      updateWhatsAppLink(whatsappTrigger.closest(COMPATIBILITY_SELECTOR));
    }
  });

  document.addEventListener('product-info:loaded', (event) => {
    const scope = event.target instanceof HTMLElement ? event.target : document;
    initializeCompatibility(scope);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeCompatibility(document), { once: true });
  } else {
    initializeCompatibility(document);
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, handleVariantChange);
  }
})();
